<template>
  <v-card class="mb-7">
    <v-card-text class="pa-5">
      <div class="d-sm-flex flex-column align-center justify-space-between">
        <div class="ml-3 d-flex justify-space-between w-100">
          <div>
            <h2 class="font-weight-regular title">Secciones</h2>
            <h6 class="body-2 mb-1 subtitle-2 font-weight-light">Datos de registrados</h6>
          </div>
          <div class="d-flex gap-3">
            <v-btn
              color="secondary"
              class="mt-3 mt-md-0 mr-2"
              :disabled="selectedIds.length === 0 || exporting"
              :loading="exporting"
              @click="exportSelected"
            >
              <v-icon left>mdi-download</v-icon>
              Exportar seleccionados
            </v-btn>
            <v-btn
              color="primary"
              class="mt-3 mt-md-0"
              :disabled="selectedIds.length === 0 || exportingMatrix"
              :loading="exportingMatrix"
              @click="exportRegionMatrix"
            >
              <v-icon left>mdi-table-multiple</v-icon>
              Exportar Secciones por región 
            </v-btn>
            <v-btn
              color="success"
              class="mt-3 mt-md-0"
              :disabled="selectedIds.length === 0 || exportingInstitucion"
              :loading="exportingInstitucion"
              @click="exportInstitucionMatrix"
            >
              <v-icon left>mdi-school</v-icon>
              Exportar Secciones por institución
            </v-btn>
          </div>
        </div>
      </div>

      <div class="d-flex align-center flex-wrap pa-3 pt-0">
        <div class="mr-4" style="max-width: 420px;">
          <v-text-field
            v-model="filters.search"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            clearable
            hide-details
            label="Buscar por nombre de sección"
            @input="debouncedFetch"
          />
        </div>

        <div class="mr-4" style="max-width: 220px;">
          <v-select
            v-model="filters.activo"
            :items="estadoItems"
            item-text="text"
            item-value="value"
            label="Estado sección"
            outlined
            dense
            clearable
            hide-details
            @change="onFilterChanged"
          />
        </div>
      </div>

      <!-- Tabla -->
      <v-data-table
        :headers="headerArray"
        :items="sections"
        :options.sync="options"
        :loading="loading"
        :items-per-page="pageSize"
        :page.sync="page"
        :server-items-length="total"
        hide-default-footer
        item-key="id"
        show-select
        v-model="selectedRows"
      >
        <template v-slot:item.nombre="{ item }">
          <div class="d-flex" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ item.nombre }}
            </h4>
          </div>
        </template>

        <template v-slot:item.fecha_inicio="{ item }">
          <div class="d-flex justify-center" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ getDateFormat(item.fecha_inicio) || '-' }}
            </h4>
          </div>
        </template>

        <template v-slot:item.fecha_fin="{ item }">
          <div class="d-flex justify-center" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ getDateFormat(item.fecha_fin) || '-' }}
            </h4>
          </div>
        </template>

        <template v-slot:item.numero_matriculas="{item}">
          <div class="d-flex justify-center" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ item.numero_matriculas }}
            </h4>
          </div>
        </template>

        <template v-slot:item.monto_total_ganado="{item}">
          <div class="d-flex justify-center" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ item.monto_total_ganado || 0 }}
            </h4>
          </div>
        </template>

        <template v-slot:item.alumnos_costo_cero="{item}">
          <div class="d-flex justify-center" style="cursor: pointer;"
               @click="$router.push({name: 'SectionDetail', params : {id: item.id }})">
            <h4 class="font-weight-medium text-no-wrap">
              {{ item.alumnos_costo_cero || 0 }}
            </h4>
          </div>
        </template>

        <template v-slot:item.canales="{item}">
          <WatchButton
            :loading="setLoadingModal(item)"
            @click="watchCanals(item.id)"
          />
        </template>

        <template v-slot:item.exportar_estudiantes="{item}">
          <v-btn
            :loading="item.loading || false"
            @click="exportStudents(item)"
            color="#FFF"
            class="download-button"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>

        <template v-slot:footer>
          <div class="pagination d-flex justify-space-between ml-auto mr-0 mt-5">
            <p class="ma-auto">{{ page }} de {{ totalPages }}</p>
            <div>
              <v-btn icon @click="goPrev" :disabled="page === 1">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn icon @click="goNext" :disabled="page === totalPages">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <CanalsModal
      v-model="openModalCanals"
      persistent
      :detail="currentModal || []"
      @close="openModalCanals=false"
    />
  </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import WatchButton from '@/components/dashboardComponents/section/WatchButton.vue'
import CanalsModal from '@/components/dashboardComponents/section/CanalsModal.vue'
import { downloadCsv } from '../../utils/common'

export default {
  components: { WatchButton, CanalsModal },
  data: () => ({
    loading: false,
    exporting: false,                    
    page: 1,
    total: 0,
    pageSize: 20,
    headerArray: [
      { text: 'Nombre de la sección', value: 'nombre',               align: 'start',  sortable: true  },
      { text: 'Fecha de inicio',      value: 'fecha_inicio',         align: 'center', sortable: true  },
      { text: 'Fecha de fin',         value: 'fecha_fin',            align: 'center', sortable: true  },
      { text: 'Matriculados',         value: 'numero_matriculas',    align: 'center', sortable: true  },
      { text: 'Monto recaudado',      value: 'monto_total_ganado',   align: 'center', sortable: false },
      { text: 'Alumnos Costo 0',      value: 'alumnos_costo_cero',   align: 'center', sortable: false },
      { text: 'Ver canales',          value: 'canales',              align: 'center', sortable: false },
      { text: 'Exportar estudiantes', value: 'exportar_estudiantes', align: 'center', sortable: false },
    ],
    sections: [],
    selectedRows: [],
    options: {  
      sortBy: [],
      sortDesc: []
    },
    openModalCanals: false,
    currentModal: null,
    loadingModal: false,
    currentDetail: null,

    filters: { search: '', activo: '' },
    estadoItems: [
      { text: 'Todas', value: '' },
      { text: 'Activas', value: true },
      { text: 'Inactivas', value: false }
    ],
    exportingMatrix: false,
    exportingInstitucion: false,
    _searchTimeout: null
  }),
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil((this.total || 0) / this.pageSize))
    },
    selectedIds () {                     
      return this.selectedRows.map(r => r.id)
    }
  },
  async mounted() {
    await this.fetchSections()
  },
  watch: {
    // Cambiar de página -> pedir esa página
    page () { this.fetchSections() },

    // ✅ Solo cuando cambie el ORDEN (sortBy/sortDesc) reiniciamos a 1 y pedimos datos
    options: {
      deep: true,
      handler (nv, ov) {
        const sortChanged =
          JSON.stringify(nv?.sortBy || [])  !== JSON.stringify(ov?.sortBy || []) ||
          JSON.stringify(nv?.sortDesc || [])!== JSON.stringify(ov?.sortDesc || [])
        if (sortChanged) {
          if (this.page !== 1) this.page = 1
          this.fetchSections()
        }
      }
    }
  },
  methods: {
    goPrev () { if (this.page > 1) this.page-- },
    goNext () { if (this.page < this.totalPages) this.page++ },

    setLoadingModal (item) {
      return this.loadingModal && item.id === this.currentDetail
    },

    async fetchSections () {
      this.loading = true
      try {
        let ordering = ''
        if (this.options.sortBy && this.options.sortBy.length) {
          const field = this.options.sortBy[0] || ''
          const desc  = (this.options.sortDesc && this.options.sortDesc[0]) ? '-' : ''
          const allowed = ['nombre', 'fecha_inicio', 'fecha_fin', 'numero_matriculas']
          if (allowed.includes(field)) ordering = `${desc}${field}`
        }

        const params = new URLSearchParams({
          page: this.page,
          page_size: this.pageSize,
          search: this.filters.search || ''
        })
        if (ordering) params.set('ordering', ordering)
        if (this.filters.activo !== '' && this.filters.activo !== null && this.filters.activo !== undefined) {
          params.set('activo', this.filters.activo ? 'true' : 'false')
        }

        const { data } = await axios.get(`api/admin/secciones/?${params}`)
        this.sections = data?.results || []
        this.total    = Number(data?.count || 0)
        const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize))
        if (this.page > maxPage) this.page = maxPage
      } finally {
        this.loading = false
      }
    },

    debouncedFetch () {                
      clearTimeout(this._searchTimeout)
      this._searchTimeout = setTimeout(() => {
        this.page = 1
        this.fetchSections()
      }, 400)
    },
    onFilterChanged () {                
      this.page = 1
      this.fetchSections()
    },
    getDateFormat(date) {
      return moment(new Date(date)).format('DD/MM/YYYY')
    },
    async watchCanals(detail) {
      try {
        this.currentDetail = detail
        this.loadingModal = true
        const response = await axios.get(`api/admin/secciones/${detail}/canales_referencia/`)
        this.currentModal = response.data
        this.openModalCanals = true
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingModal = false
      }
    },
    async exportStudents(section) {
      try {
        this.$set(section, 'loading', true)
        const response = await axios.post(`api/admin/secciones/${section.id}/export_students/`)
        const filename = `Lista de estudiantes de la sección ${section.nombre}`
        downloadCsv(response.data, filename)
      } catch (e) {
        await this.$root.$confirm({
          title: '¡Ups!',
          message: 'Ha ocurrido un error inesperado. Inténtelo de nuevo en unos minutos.'
        })
      } finally {
        this.$set(section, 'loading', false)
      }
    },

    // ✅ Exportar selección (1 ⇒ CSV; 2+ ⇒ ZIP)
    async exportSelected () {            // <-- CAMBIO
      if (this.selectedIds.length === 0) return

      try {
        this.exporting = true
        if (this.selectedIds.length === 1) {
          // reutilizamos el export existente
          const onlyId = this.selectedIds[0]
          const section = this.sections.find(s => s.id === onlyId)
          const resp = await axios.post(`api/admin/secciones/${onlyId}/export_students/`)
          const filename = `Lista de estudiantes de la sección ${section?.nombre || onlyId}`
          downloadCsv(resp.data, filename)
          return
        }

        // 2 o más → ZIP
        const respCsv = await axios.post(
          `api/admin/secciones/export_students_bulk/`,
          { ids: this.selectedIds },
          { responseType: 'blob' }
        )
        const blob = new Blob([respCsv.data], { type: 'text/csv;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'secciones_seleccionadas.csv'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        console.error(e)
        await this.$root.$confirm({
          title: '¡Ups!',
          message: 'No fue posible exportar la selección.'
        })
      } finally {
        this.exporting = false
      }
    },
    async exportRegionMatrix() {
      if (this.selectedIds.length === 0) {
        await this.$root.$confirm({
          title: 'Aviso',
          message: 'Debes seleccionar al menos una sección.'
        })
        return
      }

      try {
        this.exportingMatrix = true
        
        const response = await axios.post(
          `api/admin/secciones/export_region_matrix/`,
          { ids: this.selectedIds, include_percentages: true},
          { responseType: 'blob' }
        )
        
        // Crear blob y descargar
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'matriz_matriculados_por_region.csv'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
        
      } catch (error) {
        console.error('Error exportando matriz:', error)
        await this.$root.$confirm({
          title: '¡Ups!',
          message: 'Error al generar la matriz de regiones. Inténtalo de nuevo.'
        })
      } finally {
        this.exportingMatrix = false
      }
    },
    async exportInstitucionMatrix() {
      if (this.selectedIds.length === 0) {
        await this.$root.$confirm({
          title: 'Aviso',
          message: 'Debes seleccionar al menos una sección.'
        })
        return
      }

      try {
        this.exportingInstitucion = true
        
        const response = await axios.post(
          `api/admin/secciones/export_institucion_matrix/`,
          { ids: this.selectedIds, include_percentages: true },
          { responseType: 'blob' }
        )
        
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'matriz_matriculados_por_institucion.csv'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
        
      } catch (error) {
        console.error('Error exportando matriz de instituciones:', error)
        await this.$root.$confirm({
          title: '¡Ups!',
          message: 'Error al generar la matriz de instituciones. Inténtalo de nuevo.'
        })
      } finally {
        this.exportingInstitucion = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.d-flex.gap-3 {
  gap: 12px;
}
.btn {
  border: 1px solid #CED4DA !important;
  text-transform: none !important;
  box-shadow: none !important;
}
.download-button {
  border: 1px solid #CED4DA !important;
  text-transform: none !important;
  box-shadow: none !important;
  color: #009EFB !important;
}
</style>
